import React from 'react';
import { FilesComponent, SimpleTabs } from 'components';
import { Access } from './access';
import { SingleResourceHeader } from './singleResourceHeader';
import { resourceTabsLabels } from './constants';
import { fileEnums, PermissionList, RolePermission } from 'utils';

export const SingleResource = ({}) => {
    const tabsContent = [
        {
            tabComponent: <FilesComponent onResource={fileEnums.RESOURCE} permissions={[PermissionList.FS_FILE_MANAGE?.code]} />,
            tab: 'Files',
        },
        RolePermission([PermissionList.MANAGE_RESOURCE?.code]) && {
            tabComponent: <Access />,
            tab: 'Access',
        },
    ];

    return (
        <>
            <div className="tab-box-wrapper">
                <SingleResourceHeader />
                <SimpleTabs defaultTab={'Files'} tabsLabels={resourceTabsLabels} tabsContent={tabsContent} />
            </div>
        </>
    );
};
